export function scrollToDOMElement(node, extraHeight = 0) {
  const headerHieght = 70;
  if (node) node.scrollIntoView();
  const scrolledY = window.scrollY;
  if (scrolledY) {
    window.scroll(0, scrolledY - headerHieght - extraHeight * 1.8);
  }
}

export default {
  scrollToDOMElement
};



// WEBPACK FOOTER //
// ./src/pages/identity-glossary/domUtils.js